// extracted by mini-css-extract-plugin
export var card = "zt3Gm";
export var category = "Ku4Wc";
export var header = "OeVBV";
export var image = "GmD10";
export var imageWrapper = "vw+LD";
export var overlayLink = "Kfomg";
export var title = "XuTEc";